/**
 * The redaction bar (D145) — how `[REDACTED]` reads on screen.
 *
 * @remarks
 * The token stays in the DOM as REAL text, for the same reason the ▷ sigil
 * does (D85): the paste is a medium this game exists for, and a CSS
 * `::before` does not copy. The stylesheet draws the bar OVER the word rather
 * than replacing it — selection, copy, print-to-text and the export all
 * carry `[REDACTED]`, which is what a redaction looks like on paper.
 *
 * To the accessibility tree it is a graphic named "redacted": a bar is an
 * image of an absence, and the name says so once, where a reader would
 * otherwise hear a bracket, a shouted word, and a bracket. The Voices dialog
 * renders the same element, so a line is heard the same way in the flow and
 * in the index.
 *
 * @packageDocumentation
 */

import { REDACTION_TOKEN } from './redaction.js';

/**
 * Render one withheld span as a bar with the accessible name "redacted".
 *
 * @returns The bar, carrying the literal token as its text
 */
export const RedactionComponent = () => (
	<span aria-label="redacted" className="redaction" role="img">
		{REDACTION_TOKEN}
	</span>
);
